export function timeslotPublic(config) {
  return config?.timeslot_checkout_active ? (config.timeslot_checkout || null) : null;
}

export function storeOrdersPaused(config) {
  const ts = timeslotPublic(config);
  return Boolean(ts?.orders_paused || ts?.store_offline);
}

export function storeOfflineMessage(config) {
  const ts = timeslotPublic(config);
  if (!ts) return "";
  return ts.offline_message || "Store is currently offline to accept any order";
}

export function slotsRequired(config) {
  const ts = timeslotPublic(config);
  return Boolean(ts?.slots_required && (ts.slots || []).length);
}

export function deliverySlots(config) {
  const ts = timeslotPublic(config);
  return Array.isArray(ts?.slots) ? ts.slots : [];
}

export function slotPrompt(config) {
  const ts = timeslotPublic(config);
  return (ts?.prompt || "Select when do you want us to deliver your order").trim();
}
